import { Box, Stack, Typography } from "@mui/material"
import { getSystemFlags } from "routes/sfg20-admin/plugins/system-tab/system-flags/controller/get-system-flags"
import { setSystemFlag } from "routes/sfg20-admin/plugins/system-tab/system-flags/controller/set-system-flag"
import { FlagRow } from "routes/sfg20-admin/plugins/system-tab/system-flags/flag-row"
import { IS_LOADING } from "lib/graphql/return-is-loading-on-each-request"
import { withInitialValue } from "lib/graphql/with-initial-value"
import { invalidate } from "lib/graphql/cache"
import { useState } from "react"

export function SystemFlagsPanel() {
    const flags = getSystemFlags.useResults({}, withInitialValue(IS_LOADING))
    const [saving, setSaving] = useState(false)
    const loading = flags === IS_LOADING

    return (
        <Box>
            {/* The page supplies the title */}
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                Runtime toggles that take effect immediately without a server restart. Changes are visible to all users.
            </Typography>

            <Stack spacing={2}>
                <FlagRow
                    label="Disable HubSpot Integration"
                    description="When enabled, licence lookups skip HubSpot and serve cached data from the database. A warning banner is shown to all users."
                    checked={!loading && !!flags.hubspotDisabled}
                    onChange={handleToggleHubspot}
                    disabled={saving || loading}
                />
            </Stack>
        </Box>
    )

    async function handleToggleHubspot(e) {
        setSaving(true)
        try {
            await setSystemFlag({ flag: "hubspotDisabled", value: e.target.checked })
            // Refresh this tab immediately; the server also broadcasts SystemFlagsChanged
            // to all clients so the app-wide banner and other tabs update on their own.
            invalidate("getSystemFlags")
            invalidate("isHubspotDisabled")
        } finally {
            setSaving(false)
        }
    }
}
